export const LOAD_COUNTRIES = 'LOAD_COUNTRIES';
export const LOAD_COUNTRIES_FAILED = 'LOAD_COUNTRIES_FAILED';
export const LOAD_STATES = 'LOAD_STATES';
export const LOAD_STATES_FAILED = 'LOAD_STATES_FAILED';

export function loadCountries(data) {
    return {
      type: LOAD_COUNTRIES,
      payload: data,
    }
}

export function loadCountriesFailed(data) {
    return {
      type: LOAD_COUNTRIES_FAILED,
      payload: data,
    }
}

export function loadStates(data) {
    return {
      type: LOAD_STATES,
      payload: data,
    }
}

export function loadStatesFailed(data) {
    return {
      type: LOAD_STATES_FAILED,
      payload: data,
    }
}



// WEBPACK FOOTER //
// ./src/actions/geo/index.js